(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name crewing.controller:RegulationDetailsCtrl
   *
   * @description
   *
   */
  angular
    .module('crewing')
    .controller('RegulationDetailsCtrl', RegulationDetailsCtrl);

  function RegulationDetailsCtrl(modalParams,$uibModalInstance,CommonMasterData) {
    var vm = this;

    vm.model = {
      regulations : modalParams.regulationMap,
      isRegulationMapWithGrouping : !!modalParams.withGrouping,
      hideFooterButtons : !!modalParams.hideFooterButtons,
      isRestrictedForAssigningIllegalDuties:  !!modalParams.isRestrictedForAssigningIllegalDuties,
      isRestrictedOperation: !!modalParams.isRestrictedOperation,
      dutyChangeReason : null,
      dutyChangeComment:null,
      dutyChangeReasonValidation: false,
      dutyChangeCommentValidation:false
    };

    initData(modalParams);

    vm.onConfirmClick = function () {
      vm.model.dutyChangeReasonValidation = false;
      vm.model.dutyChangeCommentValidation = false;

      if(vm.model.isRestrictedOperation && !vm.model.isRestrictedForAssigningIllegalDuties) {
        if(!vm.model.dutyChangeReason){
          vm.model.dutyChangeReasonValidation = true;
          return;
        }

      }

      modalParams.onAcceptPassBackParam.dutyChangeReason = !!vm.model.dutyChangeReason?vm.model.dutyChangeReason.dropdownValue:null;
      modalParams.onAcceptPassBackParam.dutyChangeComment = !!vm.model.dutyChangeComment? vm.model.dutyChangeComment : null;
      $uibModalInstance.close(modalParams.onAcceptPassBackParam);
    };

    function initData(modalParams){
      if(modalParams.isRestrictedOperation){
        loadRosterChangeReasons();
      }else {
        vm.model.dutyChangeReasons = [];
      }

    }

    function loadRosterChangeReasons(){
      CommonMasterData.getDropDownList(1, 'ALL', function(reasons) {
          vm.model.dutyChangeReasons = reasons;
          angular.forEach(reasons, function (r) {
            if(r.dropdownValue=="Operational"){
              vm.model.dutyChangeReason = r;
            }
          });

        }, function() {
          console.log('Roster change reasons retrieval error');
        }
      );
    }
  }
}());

//# sourceMappingURL=../../crewing/controllers/regulation-details-controller.js.map
